export default __webpack_public_path__ + "static/media/2.f467ff00.png";